export default [
    { value: 'GSPayments', text: 'GSPayments' },
    { value: 'Aditum', text: 'Aditum' }
]